import actionCreator, { statusAction } from 'utils/actionCreator'

import { connectGoogle } from 'actions/exceptions'

export default {
  connectGoogle,
  connectJira: (data, date) => actionCreator.post(`/service?date=${date}`, 'GET_JIRA_TASKS', data),
  connectStripe: (data, date) => actionCreator.post(`/service?date=${date}`, 'GET_STRIPE_MRR', data),
  connectGitHub: (data, date) => actionCreator.post(`/service?date=${date}`, 'GET_GIT_CHANGES', data),
  getAccount: () => actionCreator.get('/account', 'GET_ACCOUNT'),
  getChanges: date => statusAction.get(`/github/changes?date=${date}`, 'GET_GIT_CHANGES'),
  getContributions: date => actionCreator.get(`/github/contributions?date=${date}`, 'GET_GIT_CONTRIBUTIONS'),
  getEvents: date => actionCreator.get(`/google/events?date=${date}`, 'GET_GA_EVENTS'),
  getIntegrations: () => actionCreator.get('/service', 'GET_INTEGRATIONS'),
  getMRR: date => statusAction.get(`/stripe/mrr?date=${date}`, 'GET_STRIPE_MRR'),
  getPages: date => actionCreator.get(`/google/pages?date=${date}`, 'GET_GA_PAGES'),
  getSources: date => actionCreator.get(`/google/sources?date=${date}`, 'GET_GA_SOURCES'),
  getTasks: date => statusAction.get(`/jira/tasks?date=${date}`, 'GET_JIRA_TASKS'),
  getUsers: date => statusAction.get(`/google/users?date=${date}`, 'GET_GA_USERS'),
  removeIntegration: data => actionCreator.delete('/service', 'REMOVE_INTEGRATION', data),
  setChartDate: payload => ({ type: 'SET_DATE_FILTER_SUCCESS', payload }),
  setProfile: (data, date) => actionCreator.post(`/service/profile?date=${date}`, 'GET_GA_ANALYTICS', data),
  subscribeToNewsletter: data => actionCreator.post('/newsletter', 'SEND_SUBSCRIBER', data),
  updateAccount: data => actionCreator.put('/account', 'GET_ACCOUNT', data)
}